<deprecated-labeled-field
  [label]="label"
  [help]="help"
  [required]="required"
  [actionText]="actionText"
  (action)="action.emit()"
>
  <tree-multi-select-dropdown
    #dropdownElement
    [placeholder]="placeholder"
    [display]="display"
    [options]="options"
    [loadable]="loadable"
    [disabled]="disabled"
    [exact]="exact"
    [filterable]="filterable"
    (selectedOptionsChange)="valueChange.emit($event)"
    [(selectedOptions)]="value"
  >
    <ng-content></ng-content>
  </tree-multi-select-dropdown>
</deprecated-labeled-field>
